enum AccessLevel {
  INTERNAL = 1,
  PUBLIC = 2,
}

export default AccessLevel;
